import { combineReducers } from 'redux';

import BonusSlice from '../../store/Memberships/BonusSlice';
import BonusesSlice from '../../store/Memberships/BonusesSlice';
import TransactionsSlice from '../../store/Transactions/TransactionsSlice';
import CashbacksSlice from '../../store/Cashbacks/CashbacksSlice';
import StoresSlice from '../../store/Stores/StoresSlice';
import logs from '../../store/FastCash/LogsSlice';
import LogsSlice from '../../store/Memberships/LogsSlice';
import transactionsData from '../../store/Reports/TransactionsDataSlice';
import cashbacksData from '../../store/Reports/CashbacksDataSlice';
import BannerSettingsSlice from '../../store/BannerSettings/BannerSettingsSlice';
import CashbackRatesSlice from '../../store/Stores/CashbackRatesSlice';
import SupportRequestsSlice from '../../store/SupportRequests/SupportRequestsSlice';
import MessagesSlice from '../../store/Messages/MessagesSlice';
import MessagesUsersSlice from '../../store/Messages/MessagesUsersSlice';
import MembershipSlice from '../../store/FastCash/MembershipSlice';
import MembershipsSlice from '../../store/FastCash/MembershipsSlice';
import MembershipSettingsSlice from '../../store/MembershipSettings/MembershipSettingsSlice';
import PaymentSlice from '../../store/Memberships/PaymentSlice';
import PaymentsSlice from '../../store/Memberships/PaymentsSlice';
import UserSlice from '../../store/User/UserSlice';
import MultibonusSlice from '../../store/Multibonus/MultibonusSlice';
import CohortsSlice from '../../store/Cohorts/CohortsSlice';
import TaskSchedulesSlice from '../../store/TaskSchedules/TaskSchedulesSlice';
import MultipleCashbackSlice from '../../store/Cashbacks/MultipleCashbackSlice';
import SpecialCashbackRatesSlice from '../../store/FastCash/SpecialCashbackRatesRepositorySlice';
import SpecialCashbackRateSlice from '../../store/FastCash/SpecialCashbackRateRepositorySlice';

const adminReducers = combineReducers({
  BonusSlice,
  BonusesSlice,
  CashbackRatesSlice,
  CashbacksSlice,
  BannerSettingsSlice,
  logs,
  LogsSlice,
  MembershipSlice,
  MembershipsSlice,
  MembershipSettingsSlice,
  MessagesSlice,
  MessagesUsersSlice,
  PaymentSlice,
  PaymentsSlice,
  reports: combineReducers({
    transactionsData,
    cashbacksData,
  }),
  StoresSlice,
  SupportRequestsSlice,
  TransactionsSlice,
  UserSlice,
  MultibonusSlice,
  CohortsSlice,
  TaskSchedulesSlice,
  MultipleCashbackSlice,
  SpecialCashbackRatesSlice,
  SpecialCashbackRateSlice,
});

export default adminReducers;
